export function filterCapWise($store, data, floatType) {
  const stockMap = {
    high_cap_stocks: $store.state.core.highCapStocks,
    mid_cap_stocks: $store.state.core.midCapStocks,
    low_cap_stocks: $store.state.core.lowCapStocks,
    ultra_low_cap_stocks: $store.state.core.ultraLowCapStocks,
  };
  return data?.filter((i) => {
    const stockList = stockMap[floatType];
    return stockList ? stockList.includes(i.symbol) : true;
  });
}
